module.exports = __webpack_public_path__ + "img/2E763A_78A0B7_B3D1CF_14F209-256px.8697e402.png";